import { render, staticRenderFns } from "./MonitoredKeywords.vue?vue&type=template&id=17dfd220&scoped=true&"
import script from "./MonitoredKeywords.vue?vue&type=script&lang=js&"
export * from "./MonitoredKeywords.vue?vue&type=script&lang=js&"
import style0 from "./MonitoredKeywords.vue?vue&type=style&index=0&id=17dfd220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dfd220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VIcon,VRow,VTextField,VTooltip})
